import { render, staticRenderFns } from "./materialType.vue?vue&type=template&id=b256c4c0&scoped=true&"
import script from "./materialType.vue?vue&type=script&lang=js&"
export * from "./materialType.vue?vue&type=script&lang=js&"
import style0 from "./materialType.vue?vue&type=style&index=0&id=b256c4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b256c4c0",
  null
  
)

export default component.exports